export default (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: '1.3rem',
    marginRight: `${theme.spacing(1)} !important`,
    color: `${theme.palette.text.secondary} !important`,
    alignItems: 'center',
    display: 'flex',
  },
  title: {
    fontWeight: 700,
    backgroundColor: '#730065 !important',
    fontSize: '16px !important',
    color: 'white !important',
  },
  subtitle: {
    fontWeight: '400 !important',
    marginLeft: `${theme.spacing(1)} !important`,
    color: `${theme.palette.text.secondary} !important`,
  },
});
